// Règle MAE (01/10/2026) — statut selon les documents présents sur le dossier :
//   expert désigné                              -> AWAITING_INSPECTION
//   photo avant réparation                      -> VEHICLE_INSPECTED
//   photo après réparation                      -> AWAITING_FINAL_REPORT
//   photos avant et après + rapport final       -> CLOSED
// Même règle que MAE/update_claims_status.py. Le statut ne recule jamais.
const STATUS_RANK = {
  AWAITING_INSPECTION: 1,
  VEHICLE_INSPECTED: 2,
  AWAITING_FINAL_REPORT: 3,
  CLOSED: 4,
};

export const hasDocumentType = (files, type) =>
  (files || []).some((file) => file?.metadata?.some((meta) => meta?.value === type));

export const getNextClaimStatus = (currentStatus, { hasBefore, hasAfter, hasFinalReport }) => {
  if (!STATUS_RANK[currentStatus]) return null;

  let target = null;
  if (hasBefore && hasAfter && hasFinalReport) target = "CLOSED";
  else if (hasAfter) target = "AWAITING_FINAL_REPORT";
  else if (hasBefore) target = "VEHICLE_INSPECTED";

  return target && STATUS_RANK[target] > STATUS_RANK[currentStatus] ? target : null;
};
